import React from 'react'
import Footer from "../components/footer/Footer";
import Header from "../components/header/Header";
import About from '../components/about/About'

function AboutUs() { 
  return (
    <div>
        
        <Header/>
        <About/>
        <Footer/>
    </div>
  )
}

export default AboutUs